/**
 * @generated SignedSource<<33554fabf03bfb35c69f20f2b126ed31>>
 * @relayHash 99d93ebcc8b73a21f53d592b244a903d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 738b9e5ff153a21e402b8c283f1985f255585fceb97b9c4108a07e1fc5364c36

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateSingleSelectFieldInput = {
  id: string;
  operation: JiraSingleSelectOperationInput;
};
export type JiraSingleSelectOperationInput = {
  fieldOption?: string | null | undefined;
  id?: string | null | undefined;
  operation: JiraSingleValueFieldOperations;
};
export type singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation$variables = {
  input: JiraUpdateSingleSelectFieldInput;
};
export type singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation$data = {
  readonly jira: {
    readonly updateSingleSelectField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly " $fragmentSpreads": FragmentRefs<"singleSelect_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateSingleSelectField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly fieldId: string;
        readonly fieldOption: {
          readonly color: {
            readonly colorKey: string | null | undefined;
            readonly id: string | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly optionId: string;
          readonly value: string | null | undefined;
        } | null | undefined;
        readonly fieldOptions: {
          readonly totalCount: number | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly type: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation = {
  rawResponse: singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation$rawResponse;
  response: singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation$data;
  variables: singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistinlineeditingrelayprovider": isJiraListInlineEditingEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistinlineeditingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: {
    readonly get: () => boolean;
  };
});

import isJiraListInlineEditingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-inline-editing.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "concreteType": "JiraColor",
    "kind": "LinkedField",
    "name": "color",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "colorKey"
      },
      (v4/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSingleSelectFieldPayload",
            "kind": "LinkedField",
            "name": "updateSingleSelectField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSingleSelectField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "singleSelect_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistinlineeditingrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSingleSelectFieldPayload",
            "kind": "LinkedField",
            "name": "updateSingleSelectField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSingleSelectField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "fieldId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "concreteType": "JiraOptionConnection",
                    "kind": "LinkedField",
                    "name": "fieldOptions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "totalCount"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraOption",
                    "kind": "LinkedField",
                    "name": "fieldOption",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "value"
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistinlineeditingrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v5/*: any*/)
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v5/*: any*/)
                      },
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "optionId"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "738b9e5ff153a21e402b8c283f1985f255585fceb97b9c4108a07e1fc5364c36",
    "metadata": {},
    "name": "singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistinlineeditingrelayprovider": isJiraListInlineEditingEnabled_provider
    }
  }
};
})();

(node as any).hash = "924c9500b0812097864ab29d13ad370b";

export default node;
